import { render } from "./planeamentoView2.vue?vue&type=template&id=d2ae66da"
import script from "./planeamentoView2.vue?vue&type=script&lang=js"
export * from "./planeamentoView2.vue?vue&type=script&lang=js"

import "./planeamentoView2.vue?vue&type=style&index=0&id=d2ae66da&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__